/* eslint-disable */
import React from 'react';
import styles from './NPSChart.module.css';
import {
	BarChart,
	Bar,
	XAxis,
	YAxis,
	Tooltip,
	ResponsiveContainer,
	CartesianGrid,
} from 'recharts';

type NPSChartProps = {
	title?: string;
	data: { name: string; value: number }[];

	// chart config
	height?: number;
	barColor?: string;
	gridColor?: string;

	// axis
	showXAxis?: boolean;
	showYAxis?: boolean;

	// tooltip
	showTooltip?: boolean;

	// card style
	backgroundColor?: string;
	borderRadius?: string;
	padding?: string;

	// title style
	titleColor?: string;
	titleSize?: string;
};

const NPSChart: React.FC<NPSChartProps> = ({
	title = 'Net Promoter Score',
	data,

	height = 250,
	barColor = '#0ea5e9',
	gridColor = '#e5e7eb',

	showXAxis = true,
	showYAxis = true,
	showTooltip = true,

	backgroundColor = '#ffffff',
	borderRadius = '12px',
	padding = '16px',

	titleColor = '#111827',
	titleSize = '16px',
}) => {
	const isMobile = window.innerWidth <= 480;
	return (
		<div
			className={styles.container}
			style={{
				backgroundColor,
				borderRadius,
				padding,
			}}
		>
			<h3
				className={styles.title}
				style={{ color: titleColor, fontSize: titleSize }}
			>
				{title}
			</h3>

			<ResponsiveContainer width="100%" height={isMobile ? 200 : height}>
				<BarChart
					data={data}
					margin={{ top: 10, right: 10, left: 0, bottom: 10 }}
				>
					<CartesianGrid stroke={gridColor} vertical={false} />

					<defs>
						<linearGradient
							id="npsGradient"
							x1="0"
							y1="0"
							x2="0"
							y2="1"
						>
							<stop offset="0%" stopColor="#3b82f6" />{' '}
							{/* blue top */}
							<stop offset="100%" stopColor="#10b981" />{' '}
							{/* green bottom */}
						</linearGradient>
					</defs>

					{showXAxis && (
						<XAxis
							dataKey="name"
							interval={0}
							tick={{ fontSize: isMobile ? 10 : 12 }}
						/>
					)}
					{showYAxis && (
						<YAxis
							width={isMobile ? 30 : 40}
							tick={{ fontSize: isMobile ? 10 : 12 }}
						/>
					)}

					{showTooltip && <Tooltip />}

					<Bar
						dataKey="value"
						// fill={barColor}
						fill="url(#npsGradient)" // ✅ gradient applied
						radius={[0, 0, 0, 0]}
						//  barSize={50}
						barSize={isMobile ? 18 : 40}
					/>
				</BarChart>
			</ResponsiveContainer>
		</div>
	);
};

export default NPSChart;
